/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Idea_PlaceholderInputs */

const en_idea_placeholder = /** @type {(inputs: Idea_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Example: "A daily expense tracker where I log spending via WhatsApp and see a monthly summary dashboard…"`)
};

const id_idea_placeholder = /** @type {(inputs: Idea_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contoh: "Aplikasi catat pengeluaran harian, input lewat WhatsApp, ada dashboard ringkasan bulanan…"`)
};

/**
* | output |
* | --- |
* | "Example: \"A daily expense tracker where I log spending via WhatsApp and see a monthly summary dashboard…\"" |
*
* @param {Idea_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const idea_placeholder = /** @type {((inputs?: Idea_PlaceholderInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Idea_PlaceholderInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_idea_placeholder(inputs)
	return en_idea_placeholder(inputs)
});